import { Box } from '@mui/material';

import { Callout } from '@/components/notifications/Callout/Callout';
import { EntityBeneficiariesSubform } from '@/modules/entities/EntityBeneficiariesSubform/EntityBeneficiariesSubform';
import { BENEFICIARIES_AFTER_BOTH_GRANTORS_DIE } from '@/modules/entities/EntityBeneficiariesSubform/EntityBeneficiariesSubform.constants';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';
import { AiSuggestionKind } from '@/types/schema';

const { FormComponent: BeneficiariesFormComponent } =
  new EntityBeneficiariesSubform();

export function AccessAfterBothDeathsSection() {
  const { householdId } = useHouseholdDetailsContext();

  return (
    <>
      <Box pb={3}>
        <Callout severity="info-high">
          Access after the surviving client&apos;s death only if the sub-trust
          continues to exist.
        </Callout>
      </Box>
      <BeneficiariesFormComponent
        variant="testamentaryEntity"
        householdId={householdId!}
        namespace={BENEFICIARIES_AFTER_BOTH_GRANTORS_DIE}
        suggestionKindOverride={AiSuggestionKind.SubtrustRemainderBeneficiary}
      />
    </>
  );
}
